import * as moment from "moment";
import queryString from 'query-string';
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  RSelect,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET } from "../../helper/api";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { BILL_STATUS, EXTERNAL_PORT_FEE_CATEGORY_ID } from "../../utils/Utils";


const BILL_STATUS_OPTIONS = Object.keys(BILL_STATUS).map((c) => ({
  label: BILL_STATUS[c],
  value: c,
}));


const BillExternalPortFeeManager = () => {
  const clearPagi = useRef();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    addReport: false,
    isDelete: false,
  });

  const history = useHistory();
  const location = useLocation();
  const searchParams = queryString.parse(location.search, { arrayFormat: 'bracket' })
  const [loading, setLoading] = useState(false);
  const [deleteItem, setDeleteItem] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});
  const [rangeDate, setRangeDate] = useState({
    startDate: moment(searchParams?.startDate || undefined).startOf('days').toDate(),
    endDate: moment(searchParams?.endDate || undefined).endOf('days').toDate(),
  });
  const [filter, setFilter] = useState({
    customerId: searchParams?.customerId || undefined,
    ingredientId: searchParams?.ingredientId || [],
    status: searchParams?.status || undefined,

  });
  const [customerOptions, setCustomerOptions] = useState([]);
  const [ingredientOptions, setIngredientOptions] = useState([]);

  const colTable = [
    {
      Header: "Mã",
      accessor: "id",
    },

    {
      Header: "Khách hàng",
      accessor: (item) => item?.customer?.name || "",
    },

    {
      Header: "Hàng hoá",
      accessor: (item) => item?.ingredient?.name || "",
    },
    {
      Header: "Tiền hàng(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.finalMerchandiseAmount}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={','}
        thousandsGroupStyle="thousand"
      />
    },
    {
      Header: "Trạng thái",
      accessor: (item) => item.statusText,
    },
    {
      Header: "Ngày tạo",
      accessor: (item) => item.createdAtText,
    },
    {
      Header: "Ghi chú",
      accessor: (item) => item.note
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        // onEditClick(item.id);
                        // toggle("edit");
                        history.push(`/bill-external-port-fee/${item.id}`);
                      }}
                    >
                      <Icon
                        name={item.status == "APPROVED" ? "eye" : "edit"}
                      ></Icon>
                      <span>
                        {item.status == "APPROVED" ? "Xem" : "Cập nhật"}
                      </span>
                    </DropdownItem>
                  </li>


                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        // onEditClick(item.id);
                        // toggle("edit");
                        history.push(`/bill-external-port-fee/create?duplicateId=${item.id}`);
                      }}
                    >
                      <Icon
                        name={"copy"}
                      ></Icon>
                      <span>
                        Nhân bản
                      </span>
                    </DropdownItem>
                  </li>
                  {item.status == "APPROVED" ? (
                    <></>
                  ) : (
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#dropdown"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setDeleteItem({
                            id: item.id,
                          });
                          toggle("isDelete");
                        }}
                      >
                        <Icon name="trash" className="text-danger"></Icon>
                        <span>Xoá</span>
                      </DropdownItem>
                    </li>
                  )}
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  // Changing state value when searching name
  useEffect(() => {
    const newParams = queryString.stringify({
      ...rangeDate,
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.ingredientId?.length > 0 ? { ingredientId: filter.ingredientId } : {}),
      ...(filter.status ? { status: filter.status } : {}),
      ...(filter.isExchangeInternalInventory !== undefined ? { isExchangeInternalInventory: filter.isExchangeInternalInventory } : {}),
    }, { arrayFormat: 'bracket' });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    getData();
  }, [timeNow, filter]);

  const getData = () => {
    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        startDate: moment(rangeDate.startDate).toDate(),
        endDate: moment(rangeDate.endDate).toDate(),
        ...(filter.customerId ? { customerId: filter.customerId } : {}),
        ...(filter.ingredientId?.length > 0 ? { ingredientId: filter.ingredientId } : { ingredientId: Object.values(EXTERNAL_PORT_FEE_CATEGORY_ID) }),
        ...(filter.status ? { status: filter.status } : {}),
      };

      GET(`bill`, params, true)
        .then(({ data }) => {
          const rows = data?.rows || [];
          setData([...rows]);
          setSummary({
            ...data.summary,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  };

  useEffect(() => {
    GET("ingredient", {}, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setIngredientOptions(
          data.rows.filter(c => !!EXTERNAL_PORT_FEE_CATEGORY_ID[c.id]).map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
      }
    });


    GET("customer", {}, true).then((resp) => {
      setCustomerOptions(
        resp.data?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, []);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };


  // function to close the form modal
  const onFormCancel = () => {
    setView({ isDelete: false, addReport: false });
  };

  const deleteOrder = ({ id }) => {
    if (!id) {
      return;
    }
    DELETE(`bill/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa đơn thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };


  const exportExcel = () => {
    const params = queryString.stringify({
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.ingredientId?.length > 0 ? { ingredientId: filter.ingredientId } : { ingredientId: Object.values(EXTERNAL_PORT_FEE_CATEGORY_ID) }),
      ...(filter.status ? { status: filter.status } : {}),

      token: getToken(),
    }, { arrayFormat: 'bracket' })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/bill/get-list-bills-external-port-fee-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Quản lý phí cảng bãi"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Quản lý phí cảng bãi</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">


                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Khách hàng/Nhà cung cấp"
                          options={customerOptions}
                          value={
                            customerOptions.find(
                              (c) => c.value == filter.customerId
                            ) || ""
                          }
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerId: val?.value || undefined,
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          isClearable
                          isMulti
                          placeholder='Hàng hoá'
                          options={ingredientOptions}
                          value={ingredientOptions.filter((c) => filter.ingredientId?.includes(c.value))}
                          onChange={(val) => setFilter({
                            ...filter,
                            ingredientId: val?.map((c) => c.value) || [],
                          })}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          isClearable
                          placeholder='Trạng thái'
                          options={BILL_STATUS_OPTIONS}
                          value={BILL_STATUS_OPTIONS.find((c) => c.value === filter.status)}
                          onChange={(val) => setFilter({
                            ...filter,
                            status: val?.value || undefined,
                          })}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          color="primary"
                          onClick={() => {
                            history.push("/bill-external-port-fee/create");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm</span>
                        </Button>
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button
                          color="secondary"
                          onClick={exportExcel}
                        >
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li>

                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <Table
                    notShowPagi
                    loading={loading}
                    columns={colTable}
                    data={data}
                    headerRow={(
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td colSpan={3} className="nk-tb-col">
                          <span> Tổng kết ({data?.length || 0} đơn) </span>
                        </td>

                        <td className="nk-tb-col text-right">
                          <NumericFormat
                            value={summary?.finalMerchandiseAmount || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá đơn hàng này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteItem);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

      </Content>
    </React.Fragment>
  );
};

export default BillExternalPortFeeManager;
